const $ = require('jquery');
const { isNumber } = require('lodash');

/**
 * This directive adds the following class to an element when the document scrolls at a certain direction.
 *  - is-default : default behaviour, this is added when the scroll direction is not detected.
 *  - is-scrolled-up : when the site is being scrolled up.
 *  - is-scrolled-down : when the site is being scrolled down
 * It leaves the actual implemntation of the classes up to the caller.
 */
class SlideupStickyController {
    constructor($element, $window, $timeout) {
        this.$element = $element;
        this.$window = $window;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.prevOffset = -1;
        this.scrollState = 'is-default';
    }

    $postLink() {
        this.$timeout(() => { this.activeOffset = this.getActiveOffset(); }, 0, false);
        this.$element.addClass(this.scrollState);

        this.onScroll = () => requestAnimationFrame(() => this.toggleSlideup());
        document.addEventListener('scroll', this.onScroll, { passive: true });
    }

    $onDestroy() {
        document.removeEventListener('scroll', this.onScroll, { passive: true });
    }

    getActiveOffset() {
        if (this.offset == null) {
            return 0;
        }
        if (isNumber(this.offset)) {
            return this.offset;
        }

        return $(this.offset).outerHeight();
    }

    toggleSlideup() {
        // pageYOffset for IE
        const currentScroll = this.$window.scrollY || this.$window.pageYOffset,
            delta = (currentScroll - this.prevOffset);
        let state;

        // always display as normal when the window is scrolled beyond the active offset.
        // Otherwise check the scroll difference and switch class accordingly.
        if (!(currentScroll > this.activeOffset)) {
            state = 'is-default';
        } else if (delta < 0) {
            state = 'is-scrolled-up';
        } else if (delta > 0) {
            state = 'is-scrolled-down';
        }

        if (state && this.scrollState !== state) this.changeState(state);
        this.prevOffset = currentScroll;
    }

    changeState(state) {
        this.$element.removeClass('is-default is-scrolled-down is-scrolled-up');
        this.$element.addClass(state);
        this.scrollState = state;
    }
}

const slideupStickyDirectiveDefinition = () => ({
    restrict: 'A',
    scope: {
        offset: '=?olySlideup',
    },
    controller: ['$element', '$window', '$timeout', SlideupStickyController],
    bindToController: true,
    controllerAs: '$ctrl',
});

module.exports = {
    SlideupStickyController,
    slideupStickyDirectiveDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/slideup/slideup.directive.js